<div class="login-page">
  <div class="login-brand">
    <div class="logo-icon"><mat-icon>business</mat-icon></div>
    <div>
      <strong>Trusted Technologies</strong>
      <p>HR &amp; Enterprise Platform</p>
    </div>
  </div>

  <mat-card class="login-card">
    <h1>Create account</h1>
    <p class="subtitle">Register with your organization tenant.</p>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>First name</mat-label>
        <input matInput formControlName="firstName" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Last name</mat-label>
        <input matInput formControlName="lastName" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" autocomplete="username" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password" autocomplete="new-password" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Confirm password</mat-label>
        <input matInput type="password" formControlName="confirmPassword" autocomplete="new-password" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Tenant slug</mat-label>
        <input matInput formControlName="tenantSlug" placeholder="acme" />
      </mat-form-field>

      @if (error()) { <div class="error-banner">{{ error() }}</div> }
      @if (message()) { <div class="success-banner">{{ message() }}</div> }

      <button mat-raised-button color="primary" class="full-width submit-btn" type="submit" [disabled]="loading() || form.invalid">
        @if (loading()) { <mat-spinner diameter="22"></mat-spinner> } @else { Register }
      </button>
    </form>

    <div class="auth-links">
      <a routerLink="/login">Already have an account?</a>
    </div>
  </mat-card>
</div>
